// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ilEG","label":"SetPasswdForm_label__39wE9"};